function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M32.927 44.703l62.146-35.88a65.852 65.852 0 0 1 65.854 0l62.146 35.88A65.855 65.855 0 0 1 256 101.735v73.86a65.855 65.855 0 0 1-32.927 57.032l-62.146 35.88a65.852 65.852 0 0 1-65.854 0l-62.146-37.981A65.855 65.855 0 0 1 0 173.494v-71.759a65.855 65.855 0 0 1 32.927-57.032",
  fill: "#01B7D4"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M181.235 177.976L139.768 104.8c-6.164-10.938-17.861-10.507-22.063 4.99-3.678 14.578-2.676 28.416-3.747 45.022-.017.262-.372.325-.49.091L76.497 80.957c2.932-2.257 4.829-5.792 4.829-9.779 0-6.818-5.527-12.345-12.345-12.345-6.818 0-12.345 5.527-12.345 12.345 0 6.819 5.527 12.346 12.345 12.346.508 0 1.005-.04 1.497-.1 15.572 40.097 32.918 86.828 39.085 97.548 4.114 10.332 18.618 7.064 18.91-4.053l1.543-58.468c.008-.303.424-.382.542-.102l29.798 70.743a21.498 21.498 0 0 0-2.667 10.398c0 11.936 9.676 21.612 21.61 21.612 11.937 0 21.613-9.676 21.613-21.612 0-11.282-8.65-20.534-19.676-21.514",
  fill: "#FFF"
});

function SvgHashnode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2302,
    height: 2500,
    viewBox: "0 0 256 278",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashnode);
export default __webpack_public_path__ + "static/media/hashnode.f9be3152.svg";
export { ForwardRef as ReactComponent };